import { defineComponent as _defineComponent } from 'vue'
import BKInput from '@/components/AppShared/BKInput.vue'
import SearchEventsDialog from '@/pages/EventsPage/ui/SearchEventsDialog.vue'
import BKSvgIcon from '@/components/AppShared/BKSvgIcon.vue'
import { mdiChevronDown, mdiChevronUp, mdiMagnify, mdiPlus } from '@mdi/js'
import { useRoute, useRouter } from 'vue-router/composables'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import store from '@/store'
import { computed, onMounted, ref, watch } from 'vue'
import { eventApi, EventDB, EventPeriod, EventSearchParams } from '@/enitites/event'
import { useVuetify } from '@/services/useVuetify'
import FilterEventsDialog from './FilterEventsDialog.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventsPage',
  setup(__props) {

const vuetify = useVuetify()
const isDesktopTablet = computed(() => vuetify.breakpoint.mdAndUp)
const router = useRouter()
const route = useRoute()

const searchParams = ref<EventSearchParams>({
  pageNumber: 0,
  pageSize: 50,
  keyword: '',
  sortBy: 'date-asc',
  tab: undefined,
  orgIds: [],
  userLat: 0,
  userLng: 0,
})

const tabs = ref<
  {
    name: Exclude<EventPeriod, 'draft'>
    title: string
    isShow: boolean
  }[]
>([
  { name: 'now', title: 'Happening now', isShow: false },
  { name: 'future', title: 'Future events', isShow: false },
  { name: 'past', title: 'Past events', isShow: false },
])

const sortBy = ref('date')
const sortDirection = ref(true)

const events = ref<EventDB[]>([])
const showNotFound = ref(false)
const infiniteId = ref(+new Date())
const loading = ref(false)
const currentTab = ref<{ name: string; title: string } | null>(null)

function resetLoading() {
  searchParams.value.pageNumber = 0
  events.value = []
  showNotFound.value = false
  infiniteId.value += 1
}

function filterByOrg(ids: number[]) {
  resetLoading()
  searchParams.value.orgIds = ids
}

function createEvent() {
  if (!store.getters.getUserDB) {
    router.push({
      name: 'Signup',
      query: { redirect: route.path },
    })
    return
  }
  router.push({ name: 'CreateEvent' })
}

async function infiniteHandler($state: { complete: () => void; loaded: () => void }) {
  loading.value = true
  searchParams.value.sortBy = `${sortBy.value}-${sortDirection.value ? 'asc' : 'desc'}`
  const data = await eventApi.getEvents(searchParams.value)
  if (typeof data === 'string') return
  searchParams.value.pageNumber += 1
  events.value.push(...data)
  if (events.value.length === 0) showNotFound.value = true
  if (data.length < searchParams.value.pageSize) $state.complete()
  else $state.loaded()
  loading.value = false
}

function getGeolocationCoordinates() {
  navigator.geolocation.getCurrentPosition((location: GeolocationPosition) => {
    searchParams.value.userLat = location.coords.latitude
    searchParams.value.userLng = location.coords.longitude
  })
}

const dateStart = ref<Date | null>(null)
const dateEnd = ref<Date | null>(null)

function clearFilter() {
  dateStart.value = null
  dateEnd.value = null
  searchParams.value.keyword = ''
}

function handleChangeTab({ tab, sortBy }: { tab: Exclude<EventPeriod, 'draft'>; sortBy: 'date-asc' | 'date-desc' }) {
  searchParams.value.tab = tab
  searchParams.value.sortBy = sortBy
}

watch([sortBy, sortDirection], () => {
  if (loading.value) return
  resetLoading()
})

const timer = ref<number | null>(null)

watch(
  () => searchParams.value.keyword,
  () => {
    if (timer.value) clearTimeout(timer.value)
    timer.value = setTimeout(() => {
      resetLoading()
      timer.value = null
    }, 1200)
  }
)

const defaultSortDirections: Record<EventPeriod, boolean> = {
  now: true,
  past: false,
  future: true,
  draft: false,
}

watch(
  () => searchParams.value.tab,
  (tab) => {
    sortDirection.value = defaultSortDirections[tab]
    searchParams.value.tab = tab
    clearFilter()
    resetLoading()
  }
)

onMounted(async () => {
  getGeolocationCoordinates()
  const availableTabs = await eventApi.getEventsAvailableTabs({ userId: 0, orgId: 0 })
  if (!availableTabs) return
  tabs.value = tabs.value.map((tab) => ({ ...tab, isShow: !!availableTabs[tab.name] }))
  const firstAvailableTab = tabs.value.find((period) => period.isShow)
  if (!firstAvailableTab) return
  searchParams.value.tab = firstAvailableTab.name
  currentTab.value = { ...firstAvailableTab }
})

return { __sfc: true,vuetify, isDesktopTablet, router, route, searchParams, tabs, sortBy, sortDirection, events, showNotFound, infiniteId, loading, currentTab, resetLoading, filterByOrg, createEvent, infiniteHandler, getGeolocationCoordinates, dateStart, dateEnd, clearFilter, handleChangeTab, timer, defaultSortDirections, BKInput, SearchEventsDialog, BKSvgIcon, mdiChevronDown, mdiChevronUp, mdiMagnify, mdiPlus, FilterEventsDialog }
}

})